const variationDimensions = {
  Color: 'カラー',
  Size: 'サイズ',
};

module.exports = {
  variationDimensions,
};
